"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var browser_bunyan_1 = require("browser-bunyan");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return browser_bunyan_1.Logger; } });
var console_formatted_stream_1 = require("@browser-bunyan/console-formatted-stream");
function generateLogger(config) {
    var remote = function (message) {
        if (!config.log.remoteUrl)
            return;
        var fetchOptions = {
            method: 'POST',
            body: JSON.stringify(message),
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(config.log.remoteUrl, fetchOptions);
    };
    var getLogLevelFromStorage = function () {
        try {
            return window.localStorage.getItem('growLogLevel');
        }
        catch (e) {
            return null;
        }
    };
    return (0, browser_bunyan_1.createLogger)({
        name: 'socital-script-v2',
        streams: [
            {
                level: getLogLevelFromStorage() || config.log.level,
                stream: new console_formatted_stream_1.ConsoleFormattedStream()
            },
            {
                level: 'error',
                stream: { write: remote }
            }
        ],
        serializers: browser_bunyan_1.stdSerializers
    });
}
exports.default = generateLogger;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9nZ2VyLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvbG9nZ2VyL0xvZ2dlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxpREFBbUU7QUFHMUQsdUZBSDZCLHVCQUFNLE9BRzdCO0FBRmYscUZBQStFO0FBSS9FLFNBQXdCLGNBQWMsQ0FBRSxNQUEyQjtJQUMvRCxJQUFNLE1BQU0sR0FBRyxVQUFDLE9BQWdCO1FBQzVCLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLFNBQVM7WUFBRSxPQUFNO1FBQ2pDLElBQU0sWUFBWSxHQUFHO1lBQ2pCLE1BQU0sRUFBRSxNQUFNO1lBQ2QsSUFBSSxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDO1lBQzdCLE9BQU8sRUFBRSxFQUFDLGNBQWMsRUFBRSxrQkFBa0IsRUFBQztTQUNoRCxDQUFBO1FBQ0QsS0FBSyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsU0FBUyxFQUFFLFlBQVksQ0FBQyxDQUFBO0lBQzdDLENBQUMsQ0FBQTtJQUVELElBQU0sc0JBQXNCLEdBQUc7UUFDM0IsSUFBSTtZQUNBLE9BQU8sTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLENBQUE7U0FDckQ7UUFBQyxPQUFPLENBQUMsRUFBRTtZQUNSLE9BQU8sSUFBSSxDQUFBO1NBQ2Q7SUFDTCxDQUFDLENBQUE7SUFFRCxPQUFPLElBQUEsNkJBQVksRUFBQztRQUNoQixJQUFJLEVBQUUsbUJBQW1CO1FBQ3pCLE9BQU8sRUFBRTtZQUNMO2dCQUNJLEtBQUssRUFBRSxzQkFBc0IsRUFBRSxJQUFJLE1BQU0sQ0FBQyxHQUFHLENBQUMsS0FBSztnQkFDbkQsTUFBTSxFQUFFLElBQUksaURBQXNCLEVBQUU7YUFDdkM7WUFDRDtnQkFDSSxLQUFLLEVBQUUsT0FBTztnQkFDZCxNQUFNLEVBQUUsRUFBQyxLQUFLLEVBQUUsTUFBTSxFQUFDO2FBQzFCO1NBQ0o7UUFDRCxXQUFXLEVBQUUsK0JBQWM7S0FDOUIsQ0FBQyxDQUFBO0FBQ04sQ0FBQztBQWpDRCxpQ0FpQ0MifQ==